let savedEmail = '';

function waitForElement(selector, callback, maxAttempts = 10, interval = 1000) {
  let attempts = 0;

  const checkElement = function() {
    const element = document.querySelector(selector);
    if (element) {
      callback(element);
    } else if (++attempts < maxAttempts) {
      setTimeout(checkElement, interval);
    } else {
      console.log(`Element ${selector} not found after ${maxAttempts} attempts`);
      callback(null);
    }
  };

  checkElement();
}

function simulateUserInput(element, value) {
  element.value = '';
  element.dispatchEvent(new Event('focus'));
  
  for (let i = 0; i < value.length; i++) {
    element.value += value[i];
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('keypress', { bubbles: true }));
  }
  
  element.dispatchEvent(new Event('change', { bubbles: true }));
  element.dispatchEvent(new Event('blur'));
}

document.addEventListener('DOMContentLoaded', function() {
  function isUserLoggedIn() {
    return shopifyCustomer !== null;
  }

  function toggleReviewBlock() {
    waitForElement('.vtl-pr-reviews__write', function(reviewBlock) {
      if (reviewBlock) {
        reviewBlock.style.display = isUserLoggedIn() ? 'flex' : 'none';
      }
    });
  }

  function setupEmailAutocomplete() {
    waitForElement('.vtl-pr__btn', function(writeReviewBtn) {
      if (writeReviewBtn) {
        writeReviewBtn.addEventListener('click', function() {
          setTimeout(function() {
            waitForElement('#vtl-pr-wf-email', function(emailInput) {
              if (emailInput && isUserLoggedIn() && shopifyCustomer.email) {
                savedEmail = shopifyCustomer.email;
                
                simulateUserInput(emailInput, savedEmail);
                applyRestrictedStyles(emailInput);

                emailInput.addEventListener('input', function(e) {
                  if (this.value !== savedEmail) {
                    simulateUserInput(this, savedEmail);
                  }
                });

                // Prevenir cambios reales
                emailInput.addEventListener('keydown', function(e) {
                  if (e.key !== 'Tab') {
                    e.preventDefault();
                  }
                });

                // Verificación periódica
                setInterval(function() {
                  if (emailInput.value !== savedEmail) {
                    simulateUserInput(emailInput, savedEmail);
                  }
                }, 1000);

                // Asegurar que el email esté presente antes de enviar el formulario
                const form = emailInput.closest('form');
                if (form) {
                  form.addEventListener('submit', function(e) {
                    if (emailInput.value !== savedEmail) {
                      e.preventDefault();
                      simulateUserInput(emailInput, savedEmail);
                      setTimeout(() => form.submit(), 100);
                    }
                  });
                }
              }
            });
          }, 500);
        });
      }
    });
  }

  function applyRestrictedStyles(emailInput) {
    emailInput.style.backgroundColor = '#f0f0f0';
    emailInput.style.color = '#666';
    emailInput.style.cursor = 'not-allowed';
    emailInput.style.opacity = '0.7';
  }

  toggleReviewBlock();
  setupEmailAutocomplete();
});